import React, { FunctionComponent } from 'react'
import { Text, IconVariantComponent } from '@afterpaytouch/core'
import styles from '../style.module.css'

interface PayMonthlyInformationPointProps {
  headerText: string
  contentText: string
  InformationIcon: IconVariantComponent
}

export const PayMonthlyInformationPoint: FunctionComponent<PayMonthlyInformationPointProps> = ({ headerText, contentText, InformationIcon }) => (
  <div className={styles.informationPoint}>
    <div className={styles.informationPointIcon}>
      <InformationIcon size='Medium' />
    </div>
    <div>
      <Text bold>{headerText}</Text>
      <Text size='S' color='Gray50'>
        {contentText}
      </Text>
    </div>
  </div>
)
